<template>
    <div
        v-if="showBetaBadge"
        role="status"
        :class="{ 'cz2__in-button': isInButton }"
        class="cz2__ai-modal-beta"
    >
        {{ $t('AI_BETA') }}
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__ai-modal-beta {
                border-radius: 8px;
                padding: 4px 8px;
                background-color: #EAEAEA;
                color: black;
                font-size: 12px;
                font-family: 'Proxima Nova', sans-serif;
                font-weight: bold;

                &.cz2__in-button {
                    position: initial;
                    // Keep button text centered
                    margin-right: -46px; // Badge width + left margin
                    margin-left: 6px;
                    background-color: rgba(255, 255, 255, 0.8);
                    font-size: 10px;
                }
            }
        }
    }
</style>

<script>
    export default {
        props: {
            isInButton: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            globalSettings() {
                return this.$store.state.customizer.globalSettings?.blueprint?.custom;
            },

            showBetaBadge() {
                return this.globalSettings['fun-ai-selfie-beta'] === 'true';
            },
        },
    };
</script>
